import ReactDatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import { useServerDate } from "services/ServerDateContext";
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const DatePick_MI = (props) => {
    const serverDate = new Date(useServerDate());
    var setMinMax = (props?.noMinMax) ? false : true

    let minDate = new Date(serverDate);
    let maxDate = new Date(serverDate);

    if (props?.setToday) {
        minDate.setDate(serverDate.getDate());
    } else {
        minDate.setDate(serverDate.getDate() + 1);
    }

    maxDate.setDate(serverDate.getDate() + 30);

    if (props?.set30Days) {
        minDate = new Date(serverDate);
        maxDate = new Date(serverDate);
        minDate.setDate(serverDate.getDate() - 30);
        maxDate.setDate(serverDate.getDate() + 30);
    } else if (props?.set1Year) {
        minDate = new Date(serverDate);
        maxDate = new Date(serverDate);
        minDate.setDate(serverDate.getDate() - 365);
        maxDate.setDate(serverDate.getDate());
    }
    
    var displayCalendar = props?.displayCalendar ? props?.displayCalendar : "top-start"
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');

    // Formats date
    const dateFormat = (date, maxDate) => {
        var saveFormattedDate
        if (date != "" && date !== null) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();

            // Appends 0 to the front of a single digit
            if (month > 0 && month < 10) {
                month = "0" + month.toString();
            }
            if (day < 10) {
                day = "0" + day.toString();
            }

            // Sets year to current year if input exceeds range
            if (year > maxDate.getFullYear()) {
                year = maxDate.getFullYear();
            }

            saveFormattedDate = month + '/' + day + '/' + year
            props.setDateSubmit(new Date(saveFormattedDate));
        }
        else {
            saveFormattedDate = "";
            props.setDateSubmit("")
        }

        if (props?.infoKey) {
            if(props?.infoKey == "requestedEffDate"){
                props.storeValue(props.nameValue, saveFormattedDate);
            }
            else{
                props.storeValue(props.nameValue, saveFormattedDate, props.infoKey)
            }
        }
        else {
            props.storeValue(props.nameValue, saveFormattedDate);
        }
        
    }
    const { dateSubmit = "" } = props
    return (
        <>
            <ReactDatePicker
                minDate={setMinMax ? minDate : false}
                maxDate={setMinMax ? maxDate : false}
                popperPlacement={displayCalendar}
                popperModifiers={[
                    {
                        name: "offset"
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            rootBoundary: "viewport",
                            tether: false,
                            altAxis: true,
                        },
                    },
                ]}
                value={dateSubmit || ""}
                type={"text"}
                autoComplete="off"
                name={props?.infoKey =="requestedEffDate"?"requestedEffDate":props?.infoKey? props?.infoKey + "_" + props?.nameValue : "DateChanged"}
                placeholderText="MM/DD/YYYY"
                className="fw-light col-sm-12 btn btn-default btn-group"
                isClearable
                selected={dateSubmit ? new Date(dateSubmit) : null}
                customInput={
                    <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        keepCharPositions={true}
                        guide={true}
                        inputMode='numeric'
                    />
                }
                onChange={(text) => {
                    dateFormat(text, maxDate);
                }}
            />
        </>
    )
}

export default DatePick_MI